// AIDEV-NOTE: Only one player may sound at a time — podcast, Vimeo video or self-evaluation recording.
// Pausing every <audio> in the document won't do: the recording is `new Audio()` outside the DOM,
// Vimeo lives in a cross-origin iframe, and the classroom ambience must keep playing. [TD-383]
let stopCurrent: (() => void) | null = null;

/**
 * Called by a player that has just started; stops the one that was playing before.
 * `stop` must keep its identity for the player's lifetime — that is how a player restarting
 * itself is told apart from another one, and it must not stop itself.
 */
export const claimPlayback = (stop: () => void) => {
  if (stopCurrent !== null && stopCurrent !== stop) stopCurrent();
  stopCurrent = stop;
};
